


















































import {Component, Vue, Prop} from 'vue-property-decorator';
import _ from 'lodash';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';


@Component({
  components: {
  }
})
export default class Referrer extends mixins(PlanLimitsMixin) {
  @Prop() conditions: any;

  mounted() {
    if (!this.conditions.referrer) {
      this.$set(this.conditions, 'referrer', {
        predicate: this.predicate,
        values: []
      });
    } else {
      if (this.conditions.referrer.predicate) {
        this.predicate = this.conditions.referrer.predicate;
      }
    }
  }

  changeCustomField({ target }) {
    this.selected = _.uniq(target.value.split('\n').filter(item => !!item))
  }

  get customReferrer() {
    return this.selected.join('\n')
  }

  get tabs() {
    return [
      {
        label: this.t('From List'),
        key: 'fromList',
        icon: 'fas fa-list',
      },
      {
        label: this.t('Custom'),
        key: 'custom',
        icon: 'fas fa-pen',
      },
    ]
  }

  get predicate() {
    if (!this.conditions.referrer || !this.conditions.referrer.predicate)
      return 'CONTAINS';

    return this.conditions.referrer.predicate;
  }

  set predicate(value: string) {
    this.$set(this.conditions.referrer, 'predicate', value);
  }

  get selected() {
    if (!this.conditions.referrer)
      return [];

    return this.conditions.referrer.values.map((v: string) => !v ? `[${this.t('Empty Value')}]` : v);
  }

  set selected(value: string[]) {
    let result = value.map((e: string) => e === `[${this.t('Empty Value')}]` ? '' : e);
    this.$set(this.conditions.referrer, 'values', result);
  }

  get includeEmpty() {
    if (!this.conditions.referrer)
      return false;

    return this.conditions.referrer.values.some((v: string) => !v);
  }

  set includeEmpty(value: boolean) {
    if (value) {
      this.conditions.referrer.values.push('');
    } else {
      this.conditions.referrer.values.splice(this.conditions.referrer.values.indexOf(''), 1);
    }
  }
}
